import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Plan } from 'src/app/interfaces/plan';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-info-modal',
  templateUrl: './user-info-modal.component.html',
  styleUrls: ['./user-info-modal.component.scss'],
})
export class UserInfoModalComponent implements OnInit, OnChanges {
  @Input() user: User | undefined;

  constructor(private router: Router, private userService: UserService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {}
}
